import useSWR from 'swr';

import { fetcher } from '../index';
import type { PmqRecord, LmqStatus, ProcessStatus } from '../../interfaces/lisa';

interface ExporterStatusResponse {
    data: PmqRecord[];
    counts: Record<LmqStatus, number>;
    process: ProcessStatus;
}

export default function useLisaExporterStatus(refreshInterval = 0) {
    const { data, error, mutate } = useSWR<ExporterStatusResponse>(
        '/v1/dashboard/lisa/exporter-status',
        fetcher,
        { refreshInterval }
    );

    return {
        records: data?.data ?? [],
        counts: data?.counts ?? {} as Record<string, number>,
        process: data?.process ?? null,
        isLoading: !data && !error,
        error,
        refresh: mutate,
    };
}
